import PropTypes from 'prop-types';

import accordionFactory from './AccordionFactory';

const propTypes = {
  accordions: PropTypes.instanceOf(Map).isRequired,
  containingTab: PropTypes.string.isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
};

/**
 * Accordions represent one or more Accordions in an array.
 * A tab may define several Accordions.  Passing a Map of definitions for accordions
 * will result in an array of the corresponding Accordion components.
 */
function Accordions({ accordions, containingTab, onAccordionStateChange }) {
  const accordionComponents = [];

  accordions.forEach((value, key) => {
    const accordion = accordionFactory(value, key, containingTab, onAccordionStateChange);
    if (accordion) {
      accordionComponents.push(accordion);
    }
  });

  return accordionComponents;
}

Accordions.propTypes = propTypes;

export default Accordions;
